// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__r8tGx","questionImage":"ImageSection_questionImage__vJp-g","zoomInOut":"ImageSection_zoomInOut__-7-X5","close":"ImageSection_close__phs9+"};